import { render } from "./ModalPromoCodeDetails.vue?vue&type=template&id=18c0d9a8&scoped=true&ts=true"
import script from "./ModalPromoCodeDetails.vue?vue&type=script&lang=ts"
export * from "./ModalPromoCodeDetails.vue?vue&type=script&lang=ts"

import "./ModalPromoCodeDetails.vue?vue&type=style&index=0&id=18c0d9a8&scoped=true&lang=css"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c0d9a8"]])

export default __exports__